import _ from 'underscore';
let config = {
    CROWDFARMING_HIVE_ID: 14584,
};

function addConfig(extraConf) {
    config = _.extend(config, extraConf);
}

export { config as default, config, addConfig };
